import getRegionalOptions from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('selectLocaleOption', function selectLocaleOption(locale) {
    var optionState = getRegionalOptions();
    optionState.selectedLocale = locale;
});
//# sourceMappingURL=selectLocaleOption.js.map